import * as React from 'react';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import ButtonAttribute from './ButtonAttribute';

export default function AlertConfimation({ open, onClose, ChildrenContent }) {
  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', 
        justifyContent: 'center', alignItems: 'center' ,
        
        }}
    >
      <Paper
        variant="outlined"
        sx={{ width: { xs: '50%', sm: '50%' , md: '30%' , lg: '30%' , xl: '700px' },
        marginLeft:{xs:'40px',sm:'40px',md:'20px',lg:'0px',xl:'0px'},
         borderRadius: 4, p: 2, boxShadow: 3, position: 'relative' }}
      >
    
        <Box sx={{ p: 2 , mt:4 }}>
          {ChildrenContent}
        </Box>
      </Paper>
    </Modal>
  );
}
